/** Tipi di schedina (spec 4): singola, multipla (un esito per partita), sistema (ordini k/n con doppie e fisse). */
export const SLIP_TYPES = ['single', 'multiple', 'system'] as const
export type SlipType = (typeof SLIP_TYPES)[number]

/** Stato di un esito giocato: `void` = rimborsato (quota 1), per esempio il pari merito del miglior tiratore. */
export const SELECTION_STATUSES = ['open', 'won', 'lost', 'void'] as const
export type SelectionStatus = (typeof SELECTION_STATUSES)[number]

/** Bonus multipla: `pct` per cento in più dalla colonna con almeno `legs` eventi. */
export type BonusRule = { legs: number; pct: number }

/** Forma minima di una schedina per contare le colonne. */
export type SlipShape = {
  type: SlipType
  systemSizes?: readonly number[]
  legs: readonly { banker?: boolean; selections: readonly unknown[] }[]
}

/** Un esito dentro una colonna: indice dell'evento e dell'esito nell'evento. */
export type ColumnPick = { leg: number; selection: number }
export type Column = ColumnPick[]

export type PricedSelection = { odds: number; status: SelectionStatus; deadHeat?: number }

/** Schedina con quote e stati: quanto serve a liquidarla e a calcolarne la vincita. */
export type PricedSlip = {
  type: SlipType
  systemSizes?: readonly number[]
  stakePerColumn: number
  bonus: readonly BonusRule[]
  maxPayout: number | null
  legs: readonly { banker?: boolean; selections: readonly PricedSelection[] }[]
}
